module.exports = __webpack_public_path__ + "static/durazno8-2562d72c2deaaacc370178d456f3e74c.jpg";